import getIn from 'transmute/getIn';
import { createSelector } from 'reselect';
import { getAuth } from '../auth/selectors/getAuth';
export const getPortalDomain = createSelector(getAuth, getIn(['portal', 'domain']));